import http from './index'

export default {
  // 删除已上传的图标
  deleteAttachment (params) {
    return http.post('/front/attachment/delete', params)
  },
  // 获取已上传的图标列表
  getAttachmentList (params) {
    return http.get('/front/attachment/logoList', params)
  },
  // 获取附件列表
  getDownloadAttachment (params) {
    return http.get('/front/attachment/download/list', params)
  },
  // 获取帮助文档列表
  getDownloadHelp (params) {
    return http.get('/front/attachment/help/list', params)
  },
  // 获取加密公钥
  getPublicKey (params) {
    return http.get('/front/public/key', params)
  },
  // 修改密码
  modifyPwd (params) {
    return http.post('/front/user/modifyPwd', params)
  },
  // 判断是否需要强制修改密码
  needModifyPwd () {
    return http.get('/front/public/needModifyPwd')
  },
  // 获取基础信息（如：登录后的用户名）
  basicInfo (params) {
    return http.get('/front/common/basicInfo', params)
  },
  // 获取分组后的附件列表
  getDownloadAttachmentGroup (params) {
    return http.get('/front/attachment/download/group', params)
  },
  // 获取全部菜单用于面包屑接口
  getAllBreadCrumbsMenu () {
    return http.get('/front/menu/getAllBreadCrumbsMenu')
  },
  getAbout () {
    return http.get('/front/common/about')
  },
  // 获取待办list
  getTodoList (params) {
    return http.get('/front/message/todoList', params)
  },
  // 获取消息list
  getMsgList (params) {
    return http.get('/front/message/messageList', params)
  },
  // 标记全部已读
  markedReadAll (params) {
    return http.post('/front/message/readAllMessage', params)
  },
  // 标记全部已读
  markedRead (params) {
    return http.post(`/front/message/readMessage/${params}`)
  },
  // 获取待办消息中心menuCode
  getTlncTodoMenuId () {
    return http.get('/front/message/todoMenuId')
  },
  // 获取消息menuCode
  getTlncMSGMenuId () {
    return http.get('/front/message/messageMenuId')
  },
  getLanguageInfo () {
    return http.get('/front/displayBoard/languageInfo')
  },
  getPortalLanguageInfo () {
    return http.get('/front/displayBoard/getIndexWidgetLanguage')
  },
  // 保活接口
  keepAlive () {
    return http.get('/front/common/keepAlive')
  },
  // websocketInfo
  getWsInfo () {
    return http.get('/front/common/getToken')
  },
  // 获取待办、消息未读数量
  getUnreadCount () {
    return http.get('/front/message/getUnreadCount')
  },
  // 获取导航工具栏一级菜单显示数量
  getFirstToolLevelCount () {
    return http.get('/front/toolbar/indexToolbarCount')
  },
  // 获取看板显示数量
  getDisplayBoardShowCount () {
    return http.get('/front/displayBoard/indexDisplayBoardCount')
  },
  judgePagePower () {
    return http.get('/front/menu/getUnPermissionMenu')
  },
  menuVisitState (param) {
    return http.get('/front/menu/menuVisitState', param)
  },
  getProductAttribute (param) {
    return http.get('/front/common/getProductAttribute', param)
  },
  getGuideSysList(){
    return http.get('/front/wizard/systemWizard')
  },
  updateGuideOperation(params){
    return http.get('/front/wizard/operation',params)
  },
  getGuideList(){
    return http.get('/front/wizard/list')
  },
  getSysGuide(){
    return http.get('/front/wizard/systemWizard')
  },
  getPortalParams(){
    return http.get('/front/params')
  },
  setPortalParams(params){
    return http.post('/front/params/save',params)
  }
}
